export default __webpack_public_path__ + "static/media/Dyslipidemia-2.015fe2da.jpg";